import { validateError } from "@/utils/validation";
import { useToastStore } from "./toast-store";

export const errorToast = (error: unknown): void => {
  const pushToast = useToastStore.getState().pushToast;

  const validatedError = validateError(error);

  if (validatedError) {
    const { fields, message } = validatedError.response.data.error;

    const fieldMessages = fields ? Object.values(fields).flat().join("\n") : null;

    void pushToast({
      type: "error",
      title: "Validation Error",
      message: fieldMessages ?? message,
    });
  } else {
    void pushToast({
      type: "error",
      title: "Error",
      message: "Unknown error",
    });
  }
};
